var priceList = []

export const parseProductTableData = (apiReturnData) => {
    priceList = apiReturnData.priceList || []
    const statisticsList = apiReturnData.statisticsList || []
    
    if (statisticsList.length === 0) return []
    
    let paramData = []
    
    // 按日期分组
    for (let item of statisticsList) {
        // 处理日期格式，支持 createDay 字段
        let dateDay = item.createDay || item.dateDay || ''
        
        let param = paramData.find(p => p.date == dateDay)
        
        if (param) {
            param.productList = parseProductList(param.productList, item)
        } else {
            param = {
                date: dateDay,
                productList: parseProductList([], item),
            }
            paramData.push(param)
        }
    }
    
    // 按日期排序
    paramData.sort((a, b) => {
        // 处理不同日期格式的排序
        return a.date.localeCompare(b.date)
    })
    
    // 计算总计
    let totalParamData = { date: '总计', productList: [] }
    for (let item of statisticsList) {
        totalParamData.productList = parseProductList(totalParamData.productList, item)
    }
    paramData.push(totalParamData)
    
    return createTableData(paramData)
}

const parseProductList = (productList, item) => {
    // 获取产品名称
    let productName = item.productName || ''
    if (!productName) {
        const priceInfo = priceList.find(p => p.priceId === item.priceId)
        productName = priceInfo ? priceInfo.productName : '未知产品'
    }
    
    let productParam = productList.find(p => p.productName == productName)
    if (!productParam) {
        productParam = { productName: productName, crowdList: [] }
        productList.push(productParam)
    }
    
    // 获取人群类型
    let crowdType = item.crowdType || ''
    if (!crowdType || crowdType === 'null') {
        // 尝试从产品名称中提取人群信息
        const match = (item.productName || '').match(/\(([^)]+)\)/)
        crowdType = match ? match[1] : '普通'
    }
    
    let crowdParam = productParam.crowdList.find(c => c.crowdType == crowdType)
    if (!crowdParam) {
        crowdParam = { crowdType: crowdType, priceList: [] }
        productParam.crowdList.push(crowdParam)
    }
    
    // 获取价格、数量、金额
    let price = parseFloat(item.price) || 0
    let quantity = parseInt(item.quantity) || 0
    let amount = parseFloat(item.amount) || 0
    
    // 如果没有提供 amount，根据 price * quantity 计算
    if (amount === 0 && price > 0 && quantity > 0) {
        amount = price * quantity
    }
    
    let priceParam = crowdParam.priceList.find(p => p.price == price)
    if (priceParam) {
        priceParam.quantity += quantity
        priceParam.amount += amount
    } else {
        crowdParam.priceList.push({ price, quantity, amount })
    }
    
    return productList
}

const formatPrice = (value) => {
    if (value === null || value === undefined) return '0.00'
    let num = Number(value)
    if (isNaN(num)) return '0.00'
    // 保留两位小数，如果是整数则不显示小数部分
    let formatted = num.toFixed(2)
    return formatted.endsWith('.00') ? Math.floor(num).toString() : formatted
}

const createTableData = (paramData) => {
    let tableData = []
    let i = 1
    
    for (let param of paramData) {
        let dateRows = []
        let bigQuantity = 0
        let bigAmount = 0
        
        let productRowMap = new Map()
        
        // 按产品分组处理
        for (let product of param.productList) {
            let productStartIndex = dateRows.length
            let productDetailRowCount = 0
            let productQuantity = 0
            let productAmount = 0
            
            for (let crowd of product.crowdList) {
                let crowdRows = []
                // 按价格排序
                crowd.priceList.sort((a, b) => a.price - b.price)
                
                for (let priceData of crowd.priceList) {
                    productQuantity += priceData.quantity
                    productAmount += priceData.amount
                    bigQuantity += priceData.quantity
                    bigAmount += priceData.amount
                    
                    let tr = [
                        { value: param.date, colspan: 0, rowspan: 0, class: 'qa-td-normal' },
                        { value: product.productName, colspan: 0, rowspan: 0, class: 'qa-td-normal' },
                        { value: crowd.crowdType, colspan: 0, rowspan: 0, class: 'qa-td-normal' },
                        { value: formatPrice(priceData.price), colspan: 1, rowspan: 1, class: 'qa-td-normal' },
                        { value: priceData.quantity, colspan: 1, rowspan: 1, class: 'qa-td-normal' },
                        { value: formatPrice(priceData.amount), colspan: 1, rowspan: 1, class: 'qa-td-normal' }
                    ]
                    crowdRows.push({ tr })
                }
                
                // 设置人群列的行合并
                if (crowdRows.length > 0) {
                    crowdRows[0].tr[2].rowspan = crowdRows.length
                    crowdRows[0].tr[2].colspan = 1
                }
                dateRows.push(...crowdRows)
                productDetailRowCount += crowdRows.length
            }
            
            // 产品小计行
            let subtotalTr = [
                { value: param.date, colspan: 0, rowspan: 0, class: 'qa-td-subtotal' },
                { value: '小计', colspan: 2, rowspan: 1, class: 'qa-td-subtotal' },
                { value: productQuantity, colspan: 1, rowspan: 1, class: 'qa-td-subtotal' },
                { value: formatPrice(productAmount), colspan: 1, rowspan: 1, class: 'qa-td-subtotal' }
            ]
            dateRows.push({ tr: subtotalTr })
            
            // 记录产品名称列需要合并的行数（包括小计行）
            let totalProductRows = productDetailRowCount + 1
            productRowMap.set(productStartIndex, { rowspan: totalProductRows })
        }
        
        // 设置产品名称列的行合并
        for (let [startIdx, info] of productRowMap) {
            if (info.rowspan > 0 && dateRows[startIdx]) {
                dateRows[startIdx].tr[1].rowspan = info.rowspan
                dateRows[startIdx].tr[1].colspan = 1
            }
        }
        
        // 合计行
        let totalTr = [
            { value: param.date, colspan: 0, rowspan: 0, class: 'qa-td-total' },
            { value: '合计', colspan: 3, rowspan: 1, class: 'qa-td-total' },
            { value: bigQuantity, colspan: 1, rowspan: 1, class: 'qa-td-total' },
            { value: formatPrice(bigAmount), colspan: 1, rowspan: 1, class: 'qa-td-total' }
        ]
        dateRows.push({ tr: totalTr })
        
        // 设置日期列的行合并（合并该日期下所有行）
        if (dateRows.length > 0) {
            dateRows[0].tr[0].rowspan = dateRows.length
            dateRows[0].tr[0].colspan = 1
        }
        
        // 总计行的特殊样式
        if (i == paramData.length) {
            dateRows[0].tr[0].class = 'qa-td-merged qa-th-merged'
        }
        
        tableData.push(...dateRows)
        i++
    }
    
    return tableData
}